import axios, { AxiosResponse } from 'axios';

import {
  INewsItem,
} from '../../../components/biz/newsItem/model';
import {
  IRecommendRemoteRes,
} from '../../../../service/airiflow';

export interface IFetchNewsListParamsApiConfig {
  apiMode?: string; // restful or graphql
  method?: string; // default as get
  url: string;
}

export interface IFetchNewsListParams {
  apiConfig: IFetchNewsListParamsApiConfig;
  articleId: string;
  expectedTotalCount: number;
  langAndCountry: string;
}

export async function fetchNewsList(params: IFetchNewsListParams): Promise<IRecommendRemoteRes> {
  let reqLink: string = params.apiConfig.url;
  if (process.env.BROWSER && reqLink.indexOf('?') === -1) {
    reqLink += window.location.search;
  }
  const response: AxiosResponse<IRecommendRemoteRes> = await axios.get(reqLink, {
    params: {
      format: 'json',
    },
  });
  return response.data;
}
